import React, { Component, Fragment } from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { translate } from "react-i18next"
import Pagination from "react-js-pagination"
import NineBoxGridDrillDownBoxShape from "../../../state/shapes/NineBoxGridDrilldownBoxShape"
import { Button, ResponsiveTable } from "../../themed-html-components"
import TableRow from "../nine-box-grid/TableRow"
import TableHeader from "../nine-box-grid/TableHeader"
import { SORTCOLUMNS } from "../../../constants"

const DetailHeaderDiv = styled.div`
  display: inline-block;
  text-align: center;
  color: black;
  font-size: 18px;
`
const BoxSummaryText = styled.div`
  text-align: center;
  font-style: italic;
  color: black;
`
const BoxRecommendedActionText = styled.div`
  color: black;
`
const TableHeaders = styled.thead`
  color: black;
  background: darkgrey;
  border: 1px solid darkgrey;
`
const EmptyBox = styled.p`
  border: darkgray 1px solid;
  padding: 10px;
  color: black;
  text-align: center;
  background-color: lightgray;
  font-style: italic;
`

const defaultPageNumber = 1
const defaultPageSize = 5

class BoxDetail extends Component {
  constructor(props) {
    super(props)

    var sortState = this.getBlankSortState()
    sortState.employee.isSorted = true
    sortState.employee.isAscending = true

    this.state = {
      activePage: 1,
      orderByColumn: SORTCOLUMNS.EmployeeAsc,
      sortState: sortState,
      pageSize: defaultPageSize
    }
  }

  handlePageChange = pageNumber => {
    // Page number parameter is 1 based and not zero based
    // so subtract 1 before loading data.
    this.setState({ activePage: pageNumber })
    this.props.onChangePage(pageNumber, this.state.pageSize, this.state.orderByColumn)

    // Scroll to top of page
    window.scrollTo(0, 0)
  }

  handleSortingChange = () => {
    this.setState({ activePage: defaultPageNumber })

    this.props.onChangePage(defaultPageNumber, this.state.pageSize, this.state.orderByColumn)
  }

  sortByEmployee = isAscending => {
    var sortState = this.getBlankSortState()

    sortState.employee.isSorted = true
    sortState.employee.isAscending = !isAscending

    var column = sortState.employee.isAscending ? SORTCOLUMNS.EmployeeAsc : SORTCOLUMNS.EmployeeDesc

    this.setState(
      {
        sortState: sortState,
        orderByColumn: column
      },
      () => {
        this.handleSortingChange()
      }
    )
  }

  sortByPotential = isAscending => {
    var sortState = this.getBlankSortState()

    sortState.potential.isSorted = true
    sortState.potential.isAscending = !isAscending

    var column = sortState.potential.isAscending
      ? SORTCOLUMNS.PotentialAsc
      : SORTCOLUMNS.PotentialDesc

    this.setState(
      {
        sortState: sortState,
        orderByColumn: column
      },
      () => {
        this.handleSortingChange()
      }
    )
  }

  sortByPerformance = isAscending => {
    var sortState = this.getBlankSortState()

    sortState.performance.isSorted = true
    sortState.performance.isAscending = !isAscending

    var column = sortState.performance.isAscending
      ? SORTCOLUMNS.PerformanceAsc
      : SORTCOLUMNS.PerformanceDesc

    this.setState(
      {
        sortState: sortState,
        orderByColumn: column
      },
      () => {
        this.handleSortingChange()
      }
    )
  }

  sortByEngagement = isAscending => {
    var sortState = this.getBlankSortState()

    sortState.engagement.isSorted = true
    sortState.engagement.isAscending = !isAscending

    var column = sortState.engagement.isAscending
      ? SORTCOLUMNS.EngagementAsc
      : SORTCOLUMNS.EngagementDesc

    this.setState(
      {
        sortState: sortState,
        orderByColumn: column
      },
      () => {
        this.handleSortingChange()
      }
    )
  }

  getBlankSortState = () => {
    const sortState = {
      employee: {
        isSorted: false,
        isAscending: false
      },
      potential: {
        isSorted: false,
        isAscending: false
      },
      performance: {
        isSorted: false,
        isAscending: false
      },
      engagement: {
        isSorted: false,
        isAscending: false
      }
    }

    return sortState
  }

  changePageSize = e => {
    var selectedPageSize = e.target.value
    this.props.onChangePage(defaultPageNumber, selectedPageSize, this.state.orderByColumn)
    this.setState({
      pageSize: selectedPageSize,
      activePage: defaultPageNumber
    })
  }

  render() {
    const { title, details, t, onClickEvent } = this.props

    let showPotentialScore = false
    let showPerformanceScore = false
    let showEngagementScore = false
    let showNextJob = false
    let showDesiredLocation = false
    let showSuccessors = false
    let showPageGroupDetails = false

    const shouldShowPeformanceScore = emp => {
      if (emp.performanceScore != null) return true
      if (emp.performanceScores.length > 0) return true

      return false
    }

    const shouldShowPotentialScore = emp => {
      if (emp.potentialScore != null) return true
      if (emp.potentialScores.length > 0) return true

      return false
    }

    const shouldShowEngagementScore = emp => {
      if (emp.engagementScore != null) return true
      if (emp.engagementScores.length > 0) return true
    }

    const shouldShowPageGroupDetails = emp => {
      if (emp.pageGroupExtraDetail != null) return true
    }

    // eslint-disable-next-line array-callback-return
    details.employees.map(emp => {
      // Loop through each of the employees and check that any of them have the above flags,
      // if they do then set it to true.

      showPotentialScore = shouldShowPotentialScore(emp)

      showPerformanceScore = shouldShowPeformanceScore(emp)

      showEngagementScore = shouldShowEngagementScore(emp)

      showPageGroupDetails = shouldShowPageGroupDetails(emp)

      if (emp.nextJob && emp.nextJob.length > 0) {
        showNextJob = true
      }
      if (emp.nextLocation && emp.nextLocation.length > 0) {
        showDesiredLocation = true
      }
      if (emp.successors.length > 0) {
        showSuccessors = true
      }
    })

    const rows = details.employees.map((emp, i) => {
      return (
        <TableRow
          key={emp.employeeId}
          emp={emp}
          showPotentialScore={showPotentialScore}
          showPerformanceScore={showPerformanceScore}
          showEngagementScore={showEngagementScore}
          showPageGroupDetails={showPageGroupDetails}
          showNextJob={showNextJob}
          showDesiredLocation={showDesiredLocation}
          showSuccessors={showSuccessors}
          index={i}
          totalItemsOnCurrentPage={details.employees.length}
        />
      )
    })

    const createPageSizeSelect = (totalItemsCount) => {
      const pageSizeOptions = [5, 10, 25, 50, 100]
      const options = pageSizeOptions.map((val) => { return (<option value={val}>{val}</option>) })

      return (
        <select
          style={{ marginLeft: 5 }}
          className="form-control col-1 d-print-none"
          onChange={this.changePageSize}
        >
          {options}
        </select>
      )
    }

    return (
      <div
        className="columns col-lg-12 col-md-12"
        style={{ display: "inline-block", marginLeft: "25px" }}
      >
        {!this.props.showPeopleModal && (
          <Fragment>
            <hr />
            <div className="columns col-lg-12 col-md-12">
              <div className="col-lg-2 col-md-2" style={{ display: "inline-block" }}>
                <Button onClick={onClickEvent} extraClassNames="d-print-none">
                  <i className="mdi mdi-arrow-left" />
                  {t("Widgets.NineBoxGrid.BackToGrid")}
                </Button>
              </div>
              <DetailHeaderDiv className="col-lg-8 col-md-8">
                <p>{t(title)}</p>
              </DetailHeaderDiv>
              <div className="col-lg-2 col-md-2" style={{ display: "inline-block" }}>
                <span>&nbsp;</span>
              </div>
            </div>
          </Fragment>
        )}
        <BoxSummaryText className="columns col-lg-12 col-md-12">
          <p>{t(details.boxSummaryText)}</p>
        </BoxSummaryText>
        <BoxRecommendedActionText className="columns col-lg-12 col-md-12">
          <p>
            <span style={{ fontWeight: "Bold" }}>{t("Common.NineBoxGridAction")}</span>:{" "}
            {t(details.boxRecommendedActionText)}
          </p>
        </BoxRecommendedActionText>
        {/* No Employees */}
        {details.employees.length === 0 && <EmptyBox>{t("Widgets.NineBoxGrid.EmptyBox")}</EmptyBox>}
        {/* When there are employees */}
        {details.employees.length > 0 && (
          <ResponsiveTable>
            <TableHeaders>
              <tr>
                <TableHeader
                  title={t("Common.Employee")}
                  handleClickEvent={this.sortByEmployee}
                  isSorted={this.state.sortState.employee.isSorted}
                  isAscending={this.state.sortState.employee.isAscending}
                />
                {showPotentialScore && (
                  <TableHeader
                    style={{ textAlign: "center" }}
                    title={t("Common.PotentialScore")}
                    handleClickEvent={this.sortByPotential}
                    isSorted={this.state.sortState.potential.isSorted}
                    isAscending={this.state.sortState.potential.isAscending}
                  />
                )}
                {showPerformanceScore && (
                  <TableHeader
                    style={{ textAlign: "center" }}
                    title={t("Common.PerformanceScore")}
                    handleClickEvent={this.sortByPerformance}
                    isSorted={this.state.sortState.performance.isSorted}
                    isAscending={this.state.sortState.performance.isAscending}
                  />
                )}
                {showEngagementScore && (
                  <TableHeader
                    style={{ textAlign: "center" }}
                    title={t("Common.EngagementScore")}
                    handleClickEvent={this.sortByEngagement}
                    isSorted={this.state.sortState.engagement.isSorted}
                    isAscending={this.state.sortState.engagement.isAscending}
                  />
                )}
                <th>&nbsp;</th>
              </tr>
            </TableHeaders>
            <tbody>{rows}</tbody>
          </ResponsiveTable>
        )}
        {!(this.props.totalItemsCount <= defaultPageSize) && (
          <Fragment>
            <Pagination
              hideDisabled
              activePage={this.state.activePage}
              itemsCountPerPage={this.state.pageSize}
              totalItemsCount={this.props.totalItemsCount}
              pageRangeDisplayed={5}
              onChange={this.handlePageChange}
            />

            <div>{createPageSizeSelect(this.props.totalItemsCount)}</div>
          </Fragment>
        )}
      </div>
    )
  }
}

BoxDetail.propTypes = {
  title: PropTypes.string.isRequired,
  details: PropTypes.shape(NineBoxGridDrillDownBoxShape).isRequired,
  t: PropTypes.func.isRequired,
  onClickEvent: PropTypes.func.isRequired,
  totalItemsCount: PropTypes.number.isRequired,
  onChangePage: PropTypes.func.isRequired,
  showPeopleModal: PropTypes.bool
}

BoxDetail.defaultProps = {
  showPeopleModal: false
}

export default translate()(BoxDetail)



// WEBPACK FOOTER //
// ./src/components/charts/nine-box-grid/BoxDetail.jsx